/** @format */

import React from 'react'
import styled from 'styled-components'
import { Skeleton, Tooltip, Icon } from '@king-design/react'
import variable from 'src/static/styles/var'

export interface MetricCardProps {
  label: string
  value: React.ReactNode
  hasError?: boolean
  /** 右上角信息提示 */
  tips?: string | React.ReactNode
}

export const MetricCard: React.FC<MetricCardProps> = ({ label, value, hasError, tips }) => (
  <article className={`metric-card ${hasError ? 'metric-card-error' : ''}`} role="listitem">
    {tips ? (
      <Tooltip theme="light" hoverable position="top" slotContent={<span>{tips}</span>}>
        <Icon className="metric-card__tip k-icon-information" />
      </Tooltip>
    ) : null}
    <div className="metric-card__header">
      <span className="metric-card__label">{label}</span>
    </div>
    <span className="metric-card__value">{value}</span>
  </article>
)

export interface MetricsSectionProps {
  className?: string
  loading?: boolean
  children: React.ReactNode
  'aria-label'?: string
}

const MetricsSection: React.FC<MetricsSectionProps> = ({
  className,
  loading,
  children,
  'aria-label': ariaLabel
}) => (
  <section className={className} aria-label={ariaLabel}>
    {loading ? (
      <Skeleton loading={true} />
    ) : (
      <div className="overview-metrics__grid" role="list">
        {children}
      </div>
    )}
  </section>
)

export default styled(MetricsSection)`
  .overview-metrics__grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 12px;

    .metric-card {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 16px 0;
      border-radius: 4px;
      background: linear-gradient(96.09deg, #fafdff 0%, #f1fbff 98.58%);
      border: 1px solid #e6f7ff;

      .metric-card__tip {
        position: absolute;
        top: 8px;
        right: 8px;
        font-size: 14px;
        color: ${variable.descColor};
        cursor: pointer;
      }

      .metric-card__header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 8px;

        .metric-card__label {
          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
        }
      }

      .metric-card__value {
        font-size: 30px;
        font-weight: 600;
        line-height: 30px;
        font-family: 'DIN Alternate';

        .metric-card__suffix {
          margin-left: 4px;
          font-size: 14px;
          font-weight: 500;
          line-height: 1;
          color: ${variable.descColor};
        }
      }

      &.metric-card-error {
        background: linear-gradient(96.09deg, #fffcfc 0%, #fff1f1 98.58%);
        border: 1px solid #fff1f1;
        .metric-card__label,
        .metric-card__value,
        .metric-card__suffix {
          color: ${variable.errorColor};
        }
        .metric-card__tip {
          color: ${variable.errorColor};
        }
      }
    }
  }
`
